import { Component, Input } from '@angular/core';
import { IPaymentInfo } from '../payment.types';

@Component({
  selector: 'app-apple-pay',
  template: '',
  styles: [],
  standalone: false,
})
export class ApplePayComponent {
  @Input('paymentDetails') paymentDetails!: IPaymentInfo;
  @Input('paymentId') paymentId!: string;
  @Input('isLoading') isLoading: boolean = false;
  constructor() {}
}
